import { addDays } from "date-fns";
import { map } from "rxjs";

import { useQueryParams$ } from "../../../common/hooks/useQueryParams$";
import {
  getAttributeList,
  getDateAttribute,
} from "../../../common/searchParams.utils";
import AdminTurnConfirmationSearch from "./AdminTurnConfirmationSearch";
import AdminTurnConfirmationTable from "./AdminTurnConfirmationTable";
import { AdminTurnConfirmationParams } from "./AdminTurnConfirmation.interface";

const AdminTurnConfirmationResource = () => {
  const params$ = useQueryParams$().pipe(
    map((params: AdminTurnConfirmationParams) => {
      const volante_nums = getAttributeList(params.volante_nums);
      const withdrawal_from_date = getDateAttribute(
        params.withdrawal_from_date
      );
      const withdrawal_to_date = getDateAttribute(
        params.withdrawal_to_date,
        addDays(new Date(), 5)
      );

      return {
        ...params,
        volante_nums,
        withdrawal_from_date,
        withdrawal_to_date,
      };
    })
  );

  return (
    <div>
      <AdminTurnConfirmationSearch params$={params$} />
      <AdminTurnConfirmationTable params$={params$} />
    </div>
  );
};

export default AdminTurnConfirmationResource;
